export default __webpack_public_path__ + "static/media/avatar-neutre.3e8ed221.png";